import React, { Component } from "react";
import { Link } from "react-router-dom";

class PartnersList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { partnersList, loading } = this.props;

    return loading ? (
      <div className="loading" />
    ) : (
      <div className="themesflat-project style-2 isotope-project has-margin mg15 data-effect clearfix">
        {partnersList.map((data) => (
          <a
            href={
              data.partnerStatus == "Active"
                ? "/partner-about?id=" + data.id + "&name=" + data.partnerName
                : "#"
            }
          >
            <div
              className={data.classNames}
              key={data.id}
              style={{
                backgroundColor:
                  data.partnerType != "Standard" ? "rgb(219, 98, 123,.1)" : "",
              }}
            >
              <div className="inner">
                <div className="thumb data-effect-item has-effect-icon w40 offset-v-19 offset-h-49">
                  <div
                    style={{
                      height: "250px",
                      width: "100%",
                      background: "url(" + data.listImg + ")",
                      backgroundSize: "cover",
                    }}
                  />

                  <div className="overlay-effect bg-color-1" />
                </div>

                <div className="text-wrap">
                  <h5 className="heading">{data.partnerName}</h5>
                  <div className="elm-meta">
                    <span>
                      {data.country}{" "}
                      {data.partnerType ? (
                        <span
                          style={{
                            opacity:
                              data.partnerType != "Standard" ? "1" : ".3",
                          }}
                        >
                          | {data.partnerType}
                        </span>
                      ) : null}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        ))}
      </div>
    );
  }
}

export default PartnersList;
